module.exports = __webpack_public_path__ + "img/az.56404696.svg";